<template>
  <transition name="fade">
    <div v-if="post.author" class="welcome-post">
      <div class="image-container">
        <v-image
          :image-id="post.author.idImage"
          :default="'DefaultUserPhoto.svg'"
          class="user-photo"
        />
      </div>
      <div>
        <div>
          <span
            class="name"
            @click="goTo('userInfo', post.author.id)"
          >{{ post.author.firstName }} {{ post.author.lastName }}</span>
          <span> {{ $t('post.welcomePost.hasJoinedCommunity') }} </span>
          <span
            v-if="showCommunity"
            class="community-name"
            @click="goTo('communityPage', post.community.id)"
          >{{ post.community.name }}</span>
        </div>
        <span class="time">{{ time() }}</span>
      </div>
    </div>
  </transition>
</template>

<script>
import linkify from 'vue-linkify'
import VImage from '@/components/shared/VImage'

export default {
  name: 'WelcomePost',
  components: { VImage },
  props: {
    post: {
      type: Object,
      required: true
    },
    showCommunity: Boolean
  },
  directives: {
    linkify
  },
  methods: {
    time () {
      const createdAt = this.post.createdAt
      return this.$store.getters.getDateFromNow(createdAt)
    },
    goTo (page, id) {
      this.$router.push({ name: page, params: { id: id } })
    }
  }
}
</script>

<style lang="scss" scoped>

.welcome-post {
    display: flex;
    align-items: center;
    background: #FFFFFF;
    box-shadow: 2px 2px 8px 0 rgba(69, 69, 69, 0.20);
    border-radius: 3px;
    max-width: 606px;
    width: calc(100% - 32px);
    margin: 0.6rem 1rem;
    text-align: left;
    color: $black-color;
    letter-spacing: 0;
    line-height: 24px;
    font-size: 14px;
  @media (max-width: $header-change) {
    max-width: 80vw;
    width: calc(100% - 1rem);
    margin: 0.5rem;
  }
  @media (max-width: $small) {
    max-width: none;
    margin: 0.5rem;
  }

    .name {
      font-weight: bold;
      cursor: pointer;
    }

    .community-name {
      font-weight: bold;
      cursor: pointer;
      color: $primary-color;
    }

    .time {
      font-size: 13px;
    }
}

.user-photo {
    border-radius: 100%;
    cursor: pointer;
    height: 32px;
    margin: 10px 20px;
}

</style>
